import React from 'react';
import PropTypes from 'prop-types';

const UX_TEXT_CLASSNAME = 'ux-text';
// Possible options for as prop
const asOptions = ['title', 'heading', 'paragraph', 'action', 'input', 'label', 'caption'];

function create(TagName) {

  function Text(props) {
    const {
      as,
      className,
      children,
      size,
      text
    } = props || {};

    if (process.env.NODE_ENV !== 'production' && children) {
      console.warn(`Warning: The use of children elements within @ux/text is deprecated.
          Please use the 'text' prop instead.`);
    }

    const classNames = [UX_TEXT_CLASSNAME, className];

    if (typeof size === 'number' && size >= 0 && size < 6) {
      classNames.push(`${UX_TEXT_CLASSNAME}-size${size}`);
    }

    if (as && asOptions.includes(as)) {
      classNames.push(`${UX_TEXT_CLASSNAME}-${as}`);
    }


    return <TagName className={ classNames.filter(Boolean).join(' ') }>{ text || children }</TagName>;
  }

  /**
   *
   * @enum {Object} expected types of properties.
   * @public
   */
  Text.propTypes = {
    /** The type of text expected in the component */
    as: PropTypes.oneOf(asOptions),
    /** Deprecated, children for the component, please use text prop instead */
    children: PropTypes.node,
    /** Classes to apply to component */
    className: PropTypes.string,
    /** The size of the text, affected by the 'as' prop */
    size: PropTypes.number,
    /** Text to be displayed */
    text: PropTypes.string
  };

  return Text;
}

export const text = new Proxy(function () {}, {
  get: function get(_, tagName) {
    return create(tagName);
  }
});

export default text;
